import {ReviewHistoryDataType} from './reviews-history';

export enum ReviewHistoryFieldEnum {
    Rating = 'rating',
    Comment = 'comment',
    Reply = 'reply',
}

export type CatalogHistoryChangeType = {
    newValue: ReviewHistoryDataType['newValue'];
    oldValue: ReviewHistoryDataType['oldValue'];
};

export type CatalogHistoryGroupType = {
    comment?: CatalogHistoryChangeType;
    loggedAt: string;
    rating?: CatalogHistoryChangeType;
    source: 'history-group';
};

export type HistoryConditionItemType = {
    loggedAt: string;
    source: 'history-condition';
} & ReviewHistoryDataType;

export enum ReviewReplyHistoryActionEnum {
    Created = 'created',
    Deleted = 'deleted',
    Updated = 'updated',
}

export type HistoryReplyItemType = {
    action: ReviewReplyHistoryActionEnum;
    loggedAt: string;
    newValue: ReviewHistoryDataType['newValue'];
    oldValue: ReviewHistoryDataType['oldValue'];
    source: 'history-reply';
};
